import {createAction} from 'redux-actions';

export const GET_CONTENT_ITEM_WORK_HISTORY = 'GET_CONTENT_ITEM_WORK_HISTORY';
export const SET_CONTENT_ITEM_WORK_HISTORY = 'SET_CONTENT_ITEM_WORK_HISTORY';
export const RESET_CONTENT_ITEM_WORK_HISTORY = 'RESET_CONTENT_ITEM_WORK_HISTORY';

export const getContentItemWorkHistoryAction = createAction(
    GET_CONTENT_ITEM_WORK_HISTORY
);

export const setContentItemWorkHistoryAction = createAction(
    SET_CONTENT_ITEM_WORK_HISTORY
);

export const resetContentItemWorkHistoryAction = createAction(
    RESET_CONTENT_ITEM_WORK_HISTORY
);
